import { TimesHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';

const DeleteRecordListInstanceData = (recordListInstanceId, state, setState) => {
  if (state.isSaving !== true && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      isSaving: true,
      isSaved: false,
      arrayData: {},
      message: 'Deleting...'
    };
    setState(newState);

    const recordListInstanceIdForUrl = recordListInstanceId ? encodeURIComponent(recordListInstanceId) : 'NaN';
    const url = `/Records/RecordListInstance/${recordListInstanceIdForUrl}`;
    TimesHttpHelper(url, 'DELETE')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            isSaving: false,
            isSaved: true,
            arrayData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          isSaving: false,
          isSaved: false,
          message: message
        });
      });
  }
};

export default DeleteRecordListInstanceData;